import { render, staticRenderFns } from "./AutomatorControls.vue?vue&type=template&id=6ae4f435&scoped=true"
import script from "./AutomatorControls.vue?vue&type=script&lang=js"
export * from "./AutomatorControls.vue?vue&type=script&lang=js"
import style0 from "./AutomatorControls.vue?vue&type=style&index=0&id=6ae4f435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4f435",
  null
  
)

export default component.exports